const EMERGE_QUOTE_LOAD_ID_PATTERN = /\bQ(\d+)\b/i;

// Emerge spot quote ids use a Q prefix in email subjects (for example Q114235683).
export function normalizeEmergeMarketQuoteLoadId(raw: string): string {
  const match = raw.trim().match(EMERGE_QUOTE_LOAD_ID_PATTERN);
  if (!match?.[1]) {
    return '';
  }

  return `Q${match[1]}`;
}
